module.exports = __webpack_public_path__ + "static/media/preview-photo-walkthrough-banner.7814afd0.png";